__turbopack_context__.v({
  "app_light_theme": "StepsSimple-module-scss-module__VwdLSq__app_light_theme",
  "item": "StepsSimple-module-scss-module__VwdLSq__item",
  "itemNumber": "StepsSimple-module-scss-module__VwdLSq__itemNumber",
  "list": "StepsSimple-module-scss-module__VwdLSq__list",
  "note": "StepsSimple-module-scss-module__VwdLSq__note",
  "stepsSimple": "StepsSimple-module-scss-module__VwdLSq__stepsSimple",
  "title": "StepsSimple-module-scss-module__VwdLSq__title",
});
